import { Box, Button, CircularProgress, FormControl, Grid, MenuItem, Paper, Select } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Autocomplete, Checkbox, Pagination, TextField } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Popover from '@mui/material/Popover';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import 'jspdf-autotable';
import { useEffect, useState } from 'react';
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Swal from "sweetalert2";
import PageTitle from '../../../components/PageTitle/PageTitle';
import { settlementClaimsService } from "../../../services/settlementClaims.service";
import axios from '../../../utils/axios';
import CMSFICTEmployees from "../../../utils/strings/CMSFICTEmployees";
import { getUserId } from "../../../utils/strings/userString";
import SettlementDetailsWorkflow from "./SettlementDetailsWorkflow";
import SettlementNote from "./SettlementNote";
import SettlementPermissionModify from "./SettlementPermissionModify";
import SettlementWorkflowForwardMail from "./SettlementWorkflowForwardMail";
import SettlementWorkflowPDF from "./SettlementWorkflowPDF";

// ---------- Styled Components ----------
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
    // border:"1px solid gray",
    textAlign:"center",
    height:"10px !important",
    padding:0
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding:0,
    // border:"1px solid gray",
    textAlign:"center"

  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({

  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: '#becbd8ff', // light blue highlight
  },
  '& td': {
    padding: '12px 16px', // custom padding for all cells in the row
  },
}));

const HoverContainedChip = styled(Chip)(({ theme, color }) => {
  const colorMap = {
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    default: theme.palette.primary.main,
  };

  const chipColor = colorMap[color] ;

  return {
    cursor: "pointer",
    borderColor: chipColor,
    color: chipColor,
    backgroundColor: "transparent",
    transition: "all 0.25s ease-in-out",
    padding:"0px !important",
    fontWeight:"bold",
    "&:hover": {
      transform: "scale(1.05)",
      backgroundColor: `${chipColor} !important`, // fill background
      color: theme.palette.common.white, // white text
      borderColor: chipColor, // match border
      fontWeight: "bold",
      boxShadow: theme.shadows[2],
    }
  };
});

  const StatusList = ["All", "Uploaded","Drafted", "Initiated", "Vetted", "Verified", "Audited", "Approved", "Settled", "Sent_Back", "Bounced"];


// ---------- Main Component ----------
function SettlementWorkflow() {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    border: '2px solid #eee',
    boxShadow: '2px 2px 2px 2px #eee',
    borderRadius: "10px",
    p: 4,
  };

  const getChipProps = (status) => {
    const map = {
      Uploaded: { label: "Uploaded", color: "primary" },
      Drafted: { label: "Drafted", color: "secondary" },
      Initiated: { label: "Initiated", color: "primary" },
      Vetted: { label: "Vetted", color: "secondary" },
      Verified: { label: "Verified", color: "info" },
      Audited: { label: "Audited", color: "secondary" },
      Approved: { label: "Approved (OMC)", color: "primary" },
      Settled: { label: "Settled", color: "success" },
      Sent_Back: { label: "Sent Back", color: "warning" },
      Bounced: { label: "Bounced", color: "error" },
    };
    return map[status] || { label: status || "Unknown", color: "default" };
  };


 
  // ---------- States ----------
  const [cachedData, setCachedData] = useState({});
  const [issuerList, setIssuerList] = useState([]);
  const [issuer, setIssuer] = useState("");
  const [loadingIssuers, setLoadingIssuers] = useState(false);
  const [open, setOpen] = useState(false);
  const [noteOpen,setNoteOpen] = useState(false);
  const [mailOpen,setMailOpen] = useState(false);
  const [permissionOpen,setPermissionOpen] = useState(false);
  const [pdfDownloadOpen,setPdfDownloadOpen] = useState(false);
  const [selectedSettlementId, setSelectedSettlementId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [settlementPermissionsList, setSettlementPermissionsList] = useState([]);
  const currentUser = getUserId();
  const adminIds = CMSFICTEmployees;
 
  // Handle selecting individual checkboxes
const handleSelectRow = (id) => {
  setSelectedRows((prev) =>
    prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  );
};

// Handle select all for current page
const handleSelectAll = (e) => {
  if (e.target.checked) {
    const allIds = currentData.map((row) => row.settlement_id);
    setSelectedRows(allIds);
  } else {
    setSelectedRows([]);
  }
};

// Handle bulk approval API call
const handleBulkApprove = async () => {
  if (selectedRows.length === 0) return;
    Swal.fire({
            title: `You're going to Approve ${selectedRows.length} Investors Claim for Settlement!`,
            text: "(for example: OMC No-## & Date: DD/MM/YYYY)",
            input: 'text',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            preConfirm: (input) => {
                if (!input || input.trim() === "") {
                    Swal.showValidationMessage("Please mention the details of the OMC meeting");
                }
            },
           
          }).then((result) => {
            if (result.isConfirmed) {
                const payloadBody = {
                  settlementMstIds: selectedRows,
                  settlementMstIdLength: selectedRows.length,
                  note:result.value,
                  claimStatus: 'Approved',
                  isBulk:true
                }
                axios.post('/settlement-timeline/bulk',payloadBody)
                .then(response =>{
                  if(response.data.statusCode === 200){
                    Swal.fire({
                      position: 'center',
                      icon: 'success',
                      title: `Successfully Approved ${selectedRows.length} Investors Claim for Settlement!`,
                      // showConfirmButton: true,
                      // timer: 2000
                    })
                    // Update cached data locally
                    const cacheKey = `${pages.page_no}_${pages.page_limit}_${searchParams.dividendType}_${searchParams.claimStatus}_${searchParams.searchBy}_${searchParams.searchKeyword}_${searchParams.settlementPart}`;
                    setCachedData((prev) => {
                      const newPageData = (prev[cacheKey] || []).map((row) =>
                        selectedRows.includes(row.settlement_id)
                          ? { ...row, claimStatus: "Approved" }
                          : row
                      );
                      return { ...prev, [cacheKey]: newPageData };
                    });
                    setSelectedRows([]);
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Approval Failed',
                      text: 'There was an error approving the selected settlements.',
                })
                  }
                })
                .catch(error =>{
                  console.error("Bulk approve failed:", error);
                  Swal.fire({
                    icon: 'error',
                    title: 'Approval Failed',
                    text: 'There was an error approving the selected settlements.',
              })

                });
          }
      })


};



const handlePopoverOpen = (event, row) => {
  setAnchorEl(event.currentTarget);
  setHoveredRow(row);
};

const handlePopoverClose = () => {
  setAnchorEl(null);
  setHoveredRow(null);
};



const openPopOver = Boolean(anchorEl);

  const [searchParams, setSearchParams] = useState({
    dividendType: 'Cash',
    claimStatus: 'All',
    searchBy: "All",
    searchKeyword: "All",
    settlementPart:"All"
  });
  const [settlementNo, setSettlementNo] = useState("All");
  const [validationMessage, setValidationMessage] = useState("");
  const [digitCount, setDigitCount] = useState("");
  const [defaultStatus, setDefaultStatus] = useState("All");

  const [pages, setPages] = useState({
    page_no: 1,
    page_limit: 10,
  });



  // ---------- Fetch Data ----------
  const fetchData = async (page_no, page_limit) => {
  setLoading(true);
  
  try {
    // const res = await axios.get(
    //   `/settlement/get-claims?page_no=${page_no}&page_limit=${page_limit}&dividend_type=${searchParams.dividendType}&claim_status=${searchParams.claimStatus}&filter_type=${searchParams.searchBy}&filter_value=${searchParams.searchKeyword}&settlement_no=${settlementNo}&settlement_part=${searchParams.settlementPart}`
    // );
    const requestParams = {
      dividend_type: searchParams.dividendType,
      claim_status: searchParams.claimStatus,
      filter_type: searchParams.searchBy,
      filter_value: searchParams.searchKeyword,
      settlement_no: settlementNo,
      settlement_part: searchParams.settlementPart,
    };
    const res = await settlementClaimsService.getClaims({
                  page_no,
                  page_limit,
                  ...requestParams,
                });

    const payload = res.data?.payload;
    const cacheKey = `${page_no}_${page_limit}_${searchParams.dividendType}_${searchParams.claimStatus}_${searchParams.searchBy}_${searchParams.searchKeyword}_${searchParams.settlementPart}`;
    const totalRows = payload?.pagination?.total_count || 0;
    const firstPageData = payload?.data || [];
    let pageData = firstPageData;
    
      if (payload?.pagination?.total_count !== undefined) {
      setTotalCount(payload.pagination.total_count);
    } else {
      setTotalCount(0); // Set to 0 if no pagination info
    }
    const requestedRows = Math.min(Number(page_limit), totalRows);
    if (page_no === 1 && firstPageData.length > 0 && firstPageData.length < requestedRows) {
      const backendPageLimit = firstPageData.length;
      const totalPagesToFetch = Math.ceil(requestedRows / backendPageLimit);
      const remainingPages = await Promise.all(
        Array.from({ length: totalPagesToFetch - 1 }, (_, index) =>
          settlementClaimsService.getClaims({
            page_no: index + 2,
            page_limit: backendPageLimit,
            ...requestParams,
          })
        )
      );

      pageData = [
        ...firstPageData,
        ...remainingPages.flatMap((response) => response.data?.payload?.data || []),
      ].slice(0, requestedRows);
    }

    if (pageData.length) {
      setCachedData((prev) => ({
        ...prev,
        [cacheKey]: pageData,
      }));
    } else {
      setCachedData((prev) => ({
        ...prev,
        [cacheKey]: [],
      }));
    }
  } catch (error) {
    console.error("Fetch error:", error);
    setTotalCount(0); 
  } finally {
    setLoading(false);
  }
};
const fetchPermissionList = async () => {
  try {
    const  SettlementPermissionList = await axios.get(`/settlement-permissions/user/${userId}`);
    setSettlementPermissionsList(SettlementPermissionList.data.payload);
  } catch (error) {
    console.error("Error fetching settlement permissions:", error);
    setSettlementPermissionsList([]);
  }
};
useEffect(() => {
  let mounted = true;
   (async () => {
    const status = await getDefaultStatus();
    if (mounted) setSearchParams((prev) => ({
    ...prev,
    claimStatus: status, 
  }));
  })();
  

}, []);
useEffect(() => {
   const { searchBy, searchKeyword, claimStatus, dividendType,settlementPart } = searchParams;

   if(currentUser !== getUserId() || searchParams.claimStatus !== "Audited")
   {
    setSelectedRows([]);
   }
  // Reset validation and digit count if no keyword
  if (searchBy && searchKeyword === "") {
    setValidationMessage("");
    setDigitCount("");
    return;
  }

  let valid = true;
  let message = "";
  let shouldFetch = false;

  // --- BOID validation (exactly 16 digits)
  if (searchBy === "BOID") {
    const digitsOnly = searchKeyword.replace(/\D/g, ""); // only count digits
    const length = digitsOnly.length;
    setDigitCount(`${length}/16 digits entered`);

    if (length < 16) {
      valid = false;
      message = "Enter full 16-digit BOID";
      return;
    } else if (length === 16) {
      valid = true;
      shouldFetch = true;
    } else if (length > 16) {
      valid = false;
      message = "BOID cannot exceed 16 digits";
      return;
    }
  }

  // --- Folio validation (min 3 digits)
  else if (searchBy === "Folio") {
    setDigitCount("");
    if (searchKeyword.length < 3) {
      valid = false;
      message = "Folio number must be at least 3 digits";
      return;
    } else {
      shouldFetch = true;
    }
  }

  // --- Amount validation
  else if (searchBy === "Amount") {
    setDigitCount("");
    if (isNaN(searchKeyword)) {
      valid = false;
      message = "Amount must be a number";
      return;
    } else {
      shouldFetch = true;
    }
  }

  // --- Settlement No validation
  else if (searchBy === "SettlementNo") {
    setDigitCount("");
    if (isNaN(searchKeyword)) {
      valid = false;
      message = "Settlement No must be a number";
      return;
    } else {
      shouldFetch = true;
      valid = true;
      
    }
  }

  // --- Issuer validation
  else if (searchBy === "Issuer" && searchKeyword) {
    shouldFetch = true;
  }

  if((searchBy !== "" && searchKeyword !== "" ) || (searchBy === "" && searchKeyword === "" )) shouldFetch = true;
  if (!shouldFetch) return;
  if (valid)
  {
    setDigitCount("");
  }
  setValidationMessage(message);

  
  fetchPermissionList();
  let debounceTimer;
  if (shouldFetch) {
    setLoading(true);
    debounceTimer = setTimeout(() => {
      fetchData(pages.page_no, pages.page_limit);
    }, 800); // <-- ADJUST DEBOUNCE SPEED HERE
  }
  return () => clearTimeout(debounceTimer);

    fetchData(pages.page_no, pages.page_limit);
}, [pages.page_no, pages.page_limit, searchParams]);







  const currentCacheKey = `${pages.page_no}_${pages.page_limit}_${searchParams.dividendType}_${searchParams.claimStatus}_${searchParams.searchBy}_${searchParams.searchKeyword}_${searchParams.settlementPart}`;
  const currentData = cachedData[currentCacheKey] || [];
  const pageLimitOptions = Array.from(
    new Set(
      [10, 20, 30, 50, 100, 500, totalCount, pages.page_limit]
        .filter((num) => Number(num) > 0 && Number(num) <= Math.max(totalCount, pages.page_limit))
        .map(Number)
    )
  ).sort((a, b) => a - b);



  // ---------- Handlers ----------

const userId = getUserId();
  const canUserActOnStatus = (status) => {
  // const adminIds = CMSFICTEmployees;
  // if (adminIds.includes(userId)) return true;
  const permission = settlementPermissionsList.find(p => p.claimStatus === status && p.status === true);
  if (!permission) return false;
  
  return permission.user.id === userId;
};
const bulkApprovePermission = () => {
  // const adminIds = CMSFICTEmployees;
  // if (adminIds.includes(userId)) return true;
  const permission = settlementPermissionsList.find(p => p.claimStatus === "Bulk_Approved" && p.status === true);
  if (!permission) return false;
  
  return permission.user.id === userId;
}

const canModifySettlementPermissions = () => {
  const adminIds = CMSFICTEmployees;
  return adminIds.includes(userId);
}


  const fetchIssuerNames = async () => {
    setLoadingIssuers(true);
    try {
      const { data } = await axios.get("/issuer/get-info");
      if (data?.payload) {
        const formattedIssuerList = data.payload.map((issuer) => ({
          id: issuer.id,
          displayName: `${issuer.name} (${issuer.tradecode})`,
        }));
        setIssuerList([{ id: "All", displayName: "All (All Companies)" }, ...formattedIssuerList]);
      }
    } catch (error) {
      console.error("Error fetching issuer names:", error);
    } finally {
      setLoadingIssuers(false);
    }
  };


  const handleChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;

  // numeric restriction for certain fields
  if (
    (searchParams.searchBy === "BOID" ||
    searchParams.searchBy === "Amount" ||
    searchParams.searchBy === "SettlementNo") && name === "searchKeyword"
  ) {
    newValue = newValue.replace(/\D/g, ""); // only digits
    if(searchParams.searchBy ===  "SettlementNo" && newValue)
    {
      setSettlementNo(newValue);
    }
  }

  // if searchBy changes, reset keyword
  if (name === "searchBy") {
    setSearchParams((prev) => ({
      ...prev,
      searchBy: value,
      searchKeyword: value === "All" ? "All" : "",
    }));
    setValidationMessage("");
    if (value === "Issuer") {
      setIssuer("");
      fetchIssuerNames();
    }
  } else {
    setSearchParams((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  }
};

// ---------- Reset Button ----------
const handleReset = () => {
  setSearchParams({
    dividendType: "Cash",
    claimStatus: "All",
    searchBy: "All",
    searchKeyword: "All",
    settlementPart: "All",
  });

  setSettlementNo("All");
  setCachedData({});
  setPages({ page_no: 1, page_limit: 10 });
  setValidationMessage("");
  setDigitCount("");
  setTotalCount(0);
};
useEffect(() => {
  if (
    searchParams.dividendType === "Cash" &&
    searchParams.claimStatus === "All" &&
    searchParams.searchBy === "" &&
    searchParams.searchKeyword === "" &&
    searchParams.settlementPart === "All" &&
    settlementNo === "All"
  ) {
    fetchData(1, 10);
  }
}, [searchParams, settlementNo]);



 
  
const handleModalUpdate = (updatedRow) => {
  const cacheKey = `${pages.page_no}_${pages.page_limit}_${searchParams.dividendType}_${searchParams.claimStatus}_${searchParams.searchBy}_${searchParams.searchKeyword}_${searchParams.settlementPart}`;
  
  setCachedData((prev) => {
    const oldPageData = prev[cacheKey] || [];
    const newPageData = oldPageData.map((row) =>
      row.settlement_id === updatedRow.settlementMstId
        ? { ...row, ...updatedRow }
        : row
    );

    return {
      ...prev,
      [cacheKey]: newPageData,
    };
  });

  // Optionally: if the updated status no longer matches current filter, trigger refetch
  if (updatedRow.claimStatus !== searchParams.claimStatus && searchParams.claimStatus !== "All") {
    fetchData(pages.page_no, pages.page_limit);
  }
};





const handleDownloadExcel = async (page_no, page_limit) => {
  try {
    const res = await axios.get(
      `settlement/get-claims/download?page_no=${page_no}&page_limit=${page_limit}&dividend_type=${searchParams.dividendType}&claim_status=${searchParams.claimStatus}&filter_type=${searchParams.searchBy}&filter_value=${searchParams.searchKeyword}&settlement_no=${settlementNo}&settlement_part=${searchParams.settlementPart}`,
      {
        responseType: "blob", // 👈 IMPORTANT: tells Axios to expect a binary file
      }
    );

    // Create a blob from the response
    const blob = new Blob([res.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a temporary URL for the file
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = url;

    // Set file name — you can set a dynamic one
    link.setAttribute("download", "Settlement_Claims.xlsx");

    // Append link to the body and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
    Swal.fire({
      icon: "error",
      title: "Download Failed",
      text: `${error.message}`,
    });
  }
};


const handleSendMail = () =>{
    const mailData ={
      dividendType: searchParams.dividendType,
      claimStatus: searchParams.claimStatus,
      totalCount: totalCount,
      userId: userId
    }
    Swal.fire({
            title: `<p>Notify next responsible person that ${mailData.totalCount} claims have been <strong> ${mailData.claimStatus} </strong> <p>`,
            html: `
                <div style="text-align: center; line-height: 1.6;">
                  <strong>Dividend Type:</strong> ${mailData.dividendType}<br>
                  <strong>Claim Status:</strong> ${mailData.claimStatus}<br>
                  <strong>Total Count:</strong> ${mailData.totalCount}
                </div>
              `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
           
          }).then((result) => {
            if (result.isConfirmed) {
              try{
                    axios.post('/settlement-timeline/forward-email',mailData)
                  .then(response =>{
                    if(response.data.statusCode === 200){
                          Swal.fire({
                              position: 'center',
                              icon: 'success',
                              title: `${response.data.payload.message}`,
                              // showConfirmButton: true,
                              // timer: 2000
                            })
                    }
                  })
                  .catch(error =>{
                    console.error("Mail sending failed:", error);
                    Swal.fire({
                      icon: 'error',
                      title: 'Mail Sending Failed',
                      text: `${error.message}`,
                })
                  });
              }
              catch(error){
                console.error("Mail sending failed:", error);
                Swal.fire({ 
                  icon: 'error',
                  title: 'Mail Sending Failed',
                  text: `${error.message}`,
              });
            }

                  

          }
      })
}



const formatDateTime = (dateStr) => {
  if (!dateStr) return "";

  const d = new Date(dateStr);

  // Get day name
  const dayName = d.toLocaleDateString("en-US", { weekday: "long" });

  // Extract date parts
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  // Format time (12-hour format)
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 -> 12

  return `${dayName}, ${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};


  // ---------- JSX ----------
  return (
    <>
       <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            style={{ marginBottom: "10px" }}
          >
            {/* Left side: title */}
            <Grid item>
              <PageTitle title="Settlement Workflow" />
            </Grid>

            {/* Right side: buttons in one line */}
            
            <Grid item>
              <Grid container spacing={5} >
                <Grid item>
                    
                      {canUserActOnStatus(searchParams.claimStatus) && totalCount > 0 &&
                      
                      <Button variant="contained" color="primary" title="Send Mail" disabled={searchParams.claimStatus === "All"} onClick={handleSendMail}>
                        <ForwardToInboxIcon />
                    </Button>
                    }
                    
                </Grid> 
                 <Grid item>
                    
                      {canModifySettlementPermissions() &&
                      
                      <Button variant="contained" color="primary" title="Set Permissions" disabled={!adminIds.includes(currentUser)} 
                                onClick={()=>
                                {
                                  setPermissionOpen(true);
                                }} >
                        <PermIdentityIcon />
                    </Button>
                    }
                    
                </Grid> 
              
                  
                    <Grid item>
                        <Button variant="contained" color="primary" title="Total" >
                          Total Claims ({searchParams.claimStatus}) : {totalCount}
                        </Button>
                    </Grid>
                    
                
                  {
                    searchParams.claimStatus === "Audited" && totalCount > 0 
                    ?
                    <Grid item>
                      <Button variant="contained" color="primary" title="Select Status & Generate Note" 
                              onClick={()=>
                                {
                                  setNoteOpen(true);
                                }} 
                      >
                        <DocumentScannerIcon/>
                      </Button>
                </Grid>
                :
                null
                }
                <Grid item>
                    <Button variant="contained" color="primary" title="Download in Excel" onClick={()=>handleDownloadExcel(pages.page_no, pages.page_limit)}>
                        <PiMicrosoftExcelLogoFill size={20}/> EXCEL
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="contained" color="primary" title="Download in PDF" 
                              onClick={()=>
                                {
                                  setPdfDownloadOpen(true);
                                }} 
                      >
                        <PictureAsPdfIcon/>
                      </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

      {/* ---------- Filters ---------- */}
      <Grid container spacing={2} justifyContent="center" style={{ marginBottom: "15px"}}>
        <Grid item lg={2} md={3} sm={6} xs={12} >
          <FormControl fullWidth>
            <TextField
              select
              label="Dividend Type"
              name="dividendType"
              value={searchParams.dividendType}
              onChange={handleChange}
              variant="outlined"
              size="small"
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Stock">Stock</MenuItem>
              <MenuItem value="Delisted" disabled>Delisted</MenuItem>
            </TextField>
          </FormControl>
        </Grid>

        <Grid item lg={2} md={3} sm={6} xs={12} >
          <FormControl fullWidth>
            <TextField
              select
              label="Claim Status"
              name="claimStatus"
              value={searchParams.claimStatus}
              onChange={handleChange}
              variant="outlined"
              size="small"
            >
              {StatusList.map((s) => (
                <MenuItem key={s} value={s}>{s==="Approved" ? "Approved (OMC)" : s==="Sent_Back" ? "Sent Back" : s}</MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid item lg={2} md={3} sm={6} xs={12} >
          <FormControl fullWidth>
            <TextField
              select
              label="Search By"
              name="searchBy"
              value={searchParams.searchBy}
              onChange={handleChange}
              variant="outlined"
              size="small"
            >
              {["All","SettlementNo", "BOID", "Folio", "Amount", "Issuer"].map((s) => (
                <MenuItem key={s} value={s}>{s}</MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid item lg={3} md={6} sm={12} xs={12}>
          {searchParams.searchBy === "Issuer" ? (
            <Autocomplete
              options={issuerList}
              disableClearable
              getOptionLabel={(option) => option.displayName}
              value={issuerList.find((item) => item.id === issuer) || null}
              onChange={(_, newValue) => {
                setIssuer(newValue ? newValue.id : "All");
                setSearchParams((prev) => ({ ...prev, searchKeyword: newValue.id }));
              }}
              loading={loadingIssuers}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Issuer"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingIssuers ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              name="searchKeyword"
              disabled={!searchParams.searchBy}
              type="text"
              label={!searchParams.searchBy ? "Select Search By First" : `Enter ${searchParams.searchBy}`}
              value={searchParams.searchKeyword}
              onChange={handleChange}
              size="small"
            />
            
          )}
          {digitCount && (
            <p style={{ color: "#555", fontSize: "12px", marginTop: 2 }}>{digitCount}</p>
          )}
          {validationMessage && (
            <p style={{ color: "red", marginTop: 2 }}>{validationMessage}</p>
          )}

        </Grid>
        {searchParams.searchBy === "SettlementNo" && (
          <Grid item xs={12} sm={6} md={4} lg={2} >
            <FormControl fullWidth>
              <TextField
                select
                label="Select Part"
                name="settlementPart"
                value={searchParams.settlementPart}
                onChange={handleChange}
                variant="outlined"
                disabled={!searchParams.searchKeyword}
                size="small"
              >
                {["All","1", "2", "3", "4", "5"].map((s) => (
                  <MenuItem key={s} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        )}

        <Grid item lg={1} md={3} sm={12} xs={12} style={{ textAlign: "center" }} >
          <Button
            variant="contained"
            color="primary"
            onClick={handleReset}
            style={{marginTop:"5px"}}
          >
            Reset
          </Button>

          


        </Grid>
      </Grid>

      {/* ---------- Table ---------- */}
      {bulkApprovePermission() &&
          searchParams.claimStatus === "Audited" &&
          selectedRows.length > 0 && (
            <Box display="flex" justifyContent="flex-end" mb={2} mr={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBulkApprove}
                
              >
                <VerifiedUserIcon /> &nbsp; Approve Selected ({selectedRows.length})
              </Button>
            </Box>
          )}


      <Paper style={{ margin: "2px 10px", boxShadow: "2px 2px 2px gray",border:'1px solid gray' }}>
        <TableContainer sx={{ width: '100%', maxHeight: 460, scrollbarWidth: "none" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                    <Checkbox
                      color="primary"
                      style={{padding:0,margin:0}}
                      checked={
                        currentData.length > 0 &&
                        selectedRows.length === currentData.length
                      }
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < currentData.length
                      }
                      disabled={
                                  !bulkApprovePermission() ||
                                  searchParams.claimStatus !== "Audited"
                                }
                      onChange={handleSelectAll}
                    />
                  </StyledTableCell>
                <StyledTableCell>SL</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>BO ID</StyledTableCell>
                <StyledTableCell>Folio ID</StyledTableCell>
                <StyledTableCell >Settlement</StyledTableCell>
                <StyledTableCell >Part</StyledTableCell>
                <StyledTableCell>Issuer Name</StyledTableCell>
                
                <StyledTableCell>Amount</StyledTableCell>
                
                <StyledTableCell>Status</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
  {loading && !currentData.length ? (
    <TableRow>
      <StyledTableCell colSpan={10} align="center">
        <CircularProgress />
      </StyledTableCell>
    </TableRow>
  ) : currentData.length > 0 ? (
    <>
      {currentData.map((row, i) => (
        <StyledTableRow key={row.settlement_id}>
          <StyledTableCell>
            <Checkbox
              color="primary"
              style={{padding:0,margin:0}}
              checked={selectedRows.includes(row.settlement_id)}
              onChange={() => handleSelectRow(row.settlement_id)}
              disabled={
                !bulkApprovePermission() ||
                searchParams.claimStatus !== "Audited"
              }
            />
          </StyledTableCell>
          <StyledTableCell>
            {(pages.page_no - 1) * pages.page_limit + (i + 1)}
          </StyledTableCell>

          <StyledTableCell>{row.name}</StyledTableCell>
          <StyledTableCell>{row.bo_id}</StyledTableCell>
          <StyledTableCell>{row.folio_number}</StyledTableCell>
          <StyledTableCell>{row.settlementNo}</StyledTableCell>
          <StyledTableCell>{row.settlementPart || "N/A"}</StyledTableCell>
          <StyledTableCell>{row.issuer_name}</StyledTableCell>
          <StyledTableCell>{row.totalAmount}</StyledTableCell>

          <StyledTableCell>
            {(() => {
              const { label, color } = getChipProps(row.claimStatus);
              return (
                <HoverContainedChip
                  label={label}
                  color={color}
                  onClick={() => {
                    setSelectedSettlementId(row.settlement_id);
                    setOpen(true);
                  }}
                  aria-owns={openPopOver ? "mouse-over-popover" : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e) => handlePopoverOpen(e, row)}
                  onMouseLeave={handlePopoverClose}
                />
              );
            })()}
          </StyledTableCell>
        </StyledTableRow>
      ))}

      {/* ✅ Popover outside the map but inside the same fragment */}

          <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={openPopOver}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ fontSize: "10px", textAlign: "right",  padding:"5px" }} >
          {formatDateTime(hoveredRow?.updatedAt)}
        </Typography>
        <Typography sx={{ p: 1 }}>
          {hoveredRow?.note || ""}
        </Typography>
        <Typography sx={{ fontSize: "10px", textAlign: "right", padding:"5px" }}>
          Last Checked: {hoveredRow?.udadatedby || "N/A"}
        </Typography>

      </Popover>
      
    </>
  ) : (
    <StyledTableRow>
      <StyledTableCell colSpan={10} align="center">
        No Data Available
      </StyledTableCell>
    </StyledTableRow>
  )}
</TableBody>

          </Table>
        </TableContainer>

        {/* ---------- Pagination ---------- */}
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{paddingRight:"2px"}}>
          <Pagination
            count={Math.ceil(totalCount / pages.page_limit)}
            page={pages.page_no}
            onChange={(_, value) => setPages((p) => ({ ...p, page_no: value }))}
            color="primary"
            style={{padding:"2px 0px",margin:0,fontSize:"15px"}}
          />
          
          <FormControl variant="outlined" size="small" p={0} m={0}>
            <Select
              value={pages.page_limit}
              style={{padding:0,margin:0,height:"15px",fontSize:"15px"}}
              onChange={(e) => {
                const pageLimit = Number(e.target.value);
                setCachedData({});
                setPages({ page_no: 1, page_limit: pageLimit });
              }}
            >
              {pageLimitOptions.map((num) => (
                <MenuItem key={num} value={num}>
                  {num === totalCount ? `All (${num})` : `${num} / page`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Paper>

      {/* ---------- Settlement Details Workflow Modal ---------- */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
        style={{ overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" ,scrollbarWidth: "none"}}
      >
        <Fade in={open}>
          <Box sx={style} style={{ textAlign: "center", width: "90%", height: "95vh", maxHeight:"95vh",overflow:"auto",scrollbarWidth: "none" }}>
            <h3>Settlement Details Workflow</h3>
            <SettlementDetailsWorkflow
                          settlement_id={selectedSettlementId}
                          onUpdate={(updatedRow) => {
                            handleModalUpdate(updatedRow);
                          }}
                        />

            <Button onClick={() => setOpen(false)} variant="contained" color="primary" style={{marginTop:"10px"}}>
              <CloseIcon /> Close
            </Button>
          </Box>
        </Fade>
      </Modal>

      {/* ---------- Settlement Note Modal ---------- */}
      <Modal
        open={noteOpen}
        onClose={() => setNoteOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
        style={{ overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" ,scrollbarWidth: "none"}}
      >
        <Fade in={noteOpen}>
          <Box sx={style} style={{ textAlign: "center", width: "90%", height: "95vh", maxHeight:"95vh",overflow:"auto",scrollbarWidth: "none" }}>
            {/* <h3>Settlement Note</h3> */}
            <SettlementNote searchParams={searchParams} settlementNo = {settlementNo}
            />
            
            <Button onClick={() => setNoteOpen(false)} variant="contained" color="primary" style={{marginTop:"10px"}}>
              <CloseIcon /> Close
            </Button>
          </Box>
        </Fade>
      </Modal>

      {/* ---------- Send Mail Modal ---------- */}
      <Modal
        open={mailOpen}
        onClose={() => setMailOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
        style={{ overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" ,scrollbarWidth: "none"}}
      >
        <Fade in={mailOpen}>
          <Box sx={style} style={{ textAlign: "center", width: "90%", height: "95vh", maxHeight:"95vh",overflow:"auto",scrollbarWidth: "none" }}>
            {/* <h3>Settlement Note</h3> */}
            <SettlementWorkflowForwardMail/>
            
            <Button onClick={() => setMailOpen(false)} variant="contained" color="primary" style={{marginTop:"10px"}}>
              <CloseIcon /> Close
            </Button>
          </Box>
        </Fade>
      </Modal>

      <SettlementWorkflowPDF
                    open={pdfDownloadOpen}
                    onClose={() => setPdfDownloadOpen(false)}
                    searchParams={searchParams}
                    settlementNo={settlementNo}
        />
      <Modal
        open={permissionOpen}
        onClose={() => setPermissionOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
        style={{ overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" ,scrollbarWidth: "none"}}
      >
        <Fade in={permissionOpen}>
          <Box sx={style} style={{ textAlign: "center", width: "90%", height: "95vh", maxHeight:"95vh",overflow:"auto",scrollbarWidth: "none" }}>
            {/* <h3>Settlement Note</h3> */}
            <SettlementPermissionModify/>
            
            <Button onClick={() => setPermissionOpen(false)} variant="contained" color="primary" style={{marginTop:"10px"}}>
              <CloseIcon /> Close
            </Button>
          </Box>
        </Fade>
      </Modal>
      
    </>
  );
}

export default SettlementWorkflow;

export const getSettlementPermissions = async (userId) => {
  const  SettlementPermissionList = await axios.get(`/settlement-permissions/user/${userId}`);
  const permissionlist =  SettlementPermissionList.data.payload;
  return permissionlist;
};

export const getDefaultStatus = async  () => {
  const currentUser = getUserId();
  const permissions =  await getSettlementPermissions(currentUser);
 

  if (permissions.length > 0) {
    const defaultStatus = permissions.find(permission=> permission.defaultStatus === 1)?.claimStatus;
    
    return defaultStatus || "All";
  }

  return "All"; // fallback
};

